export default __webpack_public_path__ + "static/workshops-c0a0b4232e8d9431acbb01b1e7037601.png";